import React, { useState } from 'react';
import { Field, Formik, FormikHelpers } from 'formik';

import { FormHelperText } from '@material-ui/core';
import { Button, FormTextField } from '../../atoms';
import { ErrorObject, BaseFormProps, EditFleetEntityLinksProps } from '../../../types';
import { OffenderIdentifierType } from '../../../enums';
import { editFleetEntityLinkValidationSchema } from '../../../validators';

export const EditFleetEntityLinkForm: React.FC<BaseFormProps<EditFleetEntityLinksProps>> = ({
  initialValues,
  submitForm,
  onSuccess,
}) => {
  const [generalError, setGeneralError] = useState(null);
  const _handleFormSubmitError = (
    error: ErrorObject,
    actions: FormikHelpers<EditFleetEntityLinksProps>,
  ) => {
    actions.setSubmitting(false);
    setGeneralError(error.detail);
  };

  const _handleSubmission = (
    formData: EditFleetEntityLinksProps,
    actions: FormikHelpers<EditFleetEntityLinksProps>,
  ) => {
    submitForm(formData)
      .then(() => {
        onSuccess();
        actions.setSubmitting(false);
      })
      .catch((error: ErrorObject) => {
        _handleFormSubmitError(error, actions);
      });
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validateOnBlur
        validateOnChange={false}
        onSubmit={_handleSubmission}
        enableReinitialize
        validationSchema={editFleetEntityLinkValidationSchema}
      >
        {({
          handleSubmit,
          isSubmitting,
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleReset,
          setFieldValue,
        }) => (
          <form
            onReset={handleReset}
            onSubmit={handleSubmit}
            className="flex flex-auto flex-col gap-3 py-1 mx-7"
          >
            <p className="flex justify-center auth-heading text-center">Edit Fleet Entity Link</p>
            {generalError && <FormHelperText error>{generalError}</FormHelperText>}

            <p className="flex justify-start text-left text-xs">Fleet Entity Link Type :</p>
            <Field
              as="select"
              name="type"
              value={values.identifierType}
              onChange={(e) => setFieldValue('identifierType', parseInt(e.target.value, 10))}
            >
              <option value={OffenderIdentifierType.Brn}>Brn</option>
              <option value={OffenderIdentifierType.ProxyId}>Proxy Id</option>
            </Field>
            <p className="flex justify-start text-left text-xs">Fleet Entity Link Id :</p>
            <FormTextField
              variableName="value"
              placeholder="ID"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="w-96"
            />

            <Button
              isLoading={isSubmitting}
              onClick={handleSubmit}
              className="w-4/5 bg-secondary hover:bg-secondary-dark text-white text-base self-center my-7"
            >
              Edit Fleet Entity Link
            </Button>
          </form>
        )}
      </Formik>
    </>
  );
};
